/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColProps } from '../layout/type';
import { PropType } from 'vue';

export default {
  /** 列的偏移量（默认单位px） */
  offset: {
    type: [String, Number] as PropType<TdColProps['offset']>,
  },
  /** 列的宽度（默认单位px） */
  span: {
    type: [String, Number] as PropType<TdColProps['span']>,
  },
};
